export const DefaultLight = () => ({
	backgroundDefault: '#F3F1F1',
	backgroundPrimary: '#FFFFFF',
	backgroundPrimary60: '#FAF9F9',
	backgroundSecondary: '#E8E6E7',
});
